import MUIDialog from '@mui/material/Dialog'
import MUISlide from '@mui/material/Slide'
import React from 'react'
import type { TransitionProps } from '@mui/material/transitions'
import { Box, Typography, IconButton } from '@/CommonComponents'
interface IDialogProps {
  children: React.ReactNode
  open: boolean
  fullScreen?: boolean
  title?: string
  onClose?: () => void
}
const transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any>
  },
  ref: React.Ref<unknown>,
) {
  return <MUISlide direction="up" ref={ref} {...props} />
})
export default function Dialog({ children, open, fullScreen, title, onClose }: IDialogProps): React.JSX.Element {
  return (
    <MUIDialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      slots={{
        transition: transition,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '100%',
          padding: 2,
        }}
      >
        <Typography variant="h6" bold>
          {title}
        </Typography>
        <IconButton icon="close" onClick={onClose} />
      </Box>
      <Box sx={{ flex: 1 }}>{children}</Box>
    </MUIDialog>
  )
}
